var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card-code', {
    attrs: {
      "title": "No body (with sub-components)"
    },
    scopedSlots: _vm._u([{
      key: "code",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.codeNoBody) + " ")];
      },
      proxy: true
    }])
  }, [_c('b-media', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-media-aside', [_c('b-img', {
    attrs: {
      "src": require('@/assets/images/portrait/small/avatar-s-2.jpg'),
      "blank-color": "#ccc",
      "fluid": "",
      "alt": "placeholder"
    }
  })], 1), _c('b-media-body', {
    staticClass: "ml-1"
  }, [_c('h5', {
    staticClass: "mt-0"
  }, [_vm._v(" Media Title ")]), _c('b-card-text', [_vm._v(" Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus. ")]), _c('b-card-text', {
    staticClass: "mb-1"
  }, [_vm._v(" Donec sed odio dui. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. ")]), _c('b-media', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-media-aside', [_c('b-img', {
    attrs: {
      "src": require('@/assets/images/portrait/small/avatar-s-10.jpg'),
      "blank-color": "#ccc",
      "width": "64",
      "alt": "placeholder"
    }
  })], 1), _c('b-media-body', {
    staticClass: "ml-1"
  }, [_c('h5', {
    staticClass: "mt-0"
  }, [_vm._v(" Nested Media ")]), _c('b-card-text', [_vm._v("Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.")])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }